export const getLink = (type: string, path?: string, isCorporateAccount?: boolean) => {
  let url = `/verifications/${type}/${isCorporateAccount ? "corporate-details" : "personal-details"}`
  if (path) url += `/${path}`
  return url
}
